export class MainMenu {

  constructor() {

    jQuery(document).ready(function ($) {
      if ($('header').length > 0) {
        var offset = 175;
        var stickyNav = function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop >= offset) {
            $('header').addClass('condensed');
          } else {
            $('header').removeClass('condensed');
          }
        };
        stickyNav();
        $(window).scroll(function () {
          stickyNav();
        });
      }
    });


  }


}
